import React from 'react'
import { Avatar } from '@chakra-ui/react'

export default ({ size, name, icon, colorPalette }) => {
  return (
    <Avatar.Root shape='rounded' size={size} colorPalette={colorPalette}>
      <Avatar.Fallback name={name} icon={icon} />
    </Avatar.Root>
  )
}
